import EditEvents from './EditEvents'

export default EditEvents
